var React = require('react');

function FilterSpeed (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 16c-4.412 0-8-3.589-8-8s3.588-8 8-8 8 3.589 8 8-3.588 8-8 8zM8 1.371C4.345 1.371 1.371 4.345 1.371 8S4.345 14.629 8 14.629 14.629 11.655 14.629 8 11.655 1.371 8 1.371z","key":0}),React.createElement("path",{"d":"M8.486 11.233a.687.687 0 01-.464-1.19L10.242 8 8.021 5.956a.686.686 0 01.929-1.008L12.267 8 8.95 11.052a.68.68 0 01-.464.181z","key":1}),React.createElement("path",{"d":"M4.802 11.233a.687.687 0 01-.464-1.19L6.559 8 4.338 5.956a.685.685 0 11.928-1.008L8.584 8l-3.318 3.052a.68.68 0 01-.464.181z","key":2})]);
}

FilterSpeed.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = FilterSpeed;

FilterSpeed.default = FilterSpeed;
